module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_f_melanistic.40fa8402.png";